/** Build-time configuration. See .env.example at the repo root. */
export const env = {
  /** Absolute or same-origin URL of state.json. */
  stateUrl:
    (import.meta.env.VITE_STATE_URL as string | undefined) ||
    (import.meta.env.DEV ? '/dev/state.json' : ''),
  /** Where activity events are posted. Empty disables tracking. */
  ingestUrl: (import.meta.env.VITE_INGEST_URL as string | undefined) || '',
  /**
   * Demo tools (fake clock, demo-link handling). Always on in dev, opt-in elsewhere with
   * VITE_ENABLE_DEMO=1, so staging can be tested across every phase. Never enable in production.
   */
  demo: import.meta.env.DEV || import.meta.env.VITE_ENABLE_DEMO === '1',
};
